import React from 'react';
import { Link } from 'react-router-dom';
import HeroSlideshow from '../../components/home/HeroSlideshow';
import PartnerGrid from '../../components/home/PartnerGrid';
import Counter from '../../components/common/Counter';
import { useSite } from '../../context/SiteContext';

export default function HomePage() {
  const { settings, getImage } = useSite();

  return (
    <div>
      {/* ============ HERO ============ */}
      <section className="hero">
        <div className="container hero__inner">
          <div className="reveal">
            <span className="hero__tag">
              <span className="dot" /> Nhà phân phối đồng hành · từ 2014
            </span>
            <h1>
              Đồng hành <span className="accent">vững vàng</span> —
              <br />
              <span className="script">Nhà thuốc</span> vươn xa.
            </h1>
            <p className="hero__lead">
              Thế Thảo Pharma là nhà phân phối dược mỹ phẩm, thực phẩm chức năng và thiết bị y tế chuyên kênh OTC. Chúng tôi đồng hành cùng hơn <strong>20.000 nhà thuốc</strong> Việt Nam với cam kết hàng chuẩn, giấy đủ và dịch vụ tận tâm.
            </p>
            <div className="hero__actions">
              <Link className="btn btn--primary" to="/gioi-thieu">
                Khám phá Thế Thảo
                <svg className="arr" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M5 12h14M13 5l7 7-7 7" />
                </svg>
              </Link>
              <Link className="btn btn--ghost" to="/tuyen-dung">
                Cơ hội nghề nghiệp
              </Link>
            </div>
            <div className="hero__stats">
              <div className="stat">
                <strong><Counter end={20000} suffix="+" /></strong>
                <span className="stat-label">Nhà thuốc đồng hành</span>
              </div>
              <div className="stat">
                <strong><Counter end={12} suffix=" năm" /></strong>
                <span className="stat-label">Kinh nghiệm phân phối</span>
              </div>
              <div className="stat">
                <strong><Counter end={100} suffix="%" /></strong>
                <span className="stat-label">Hàng xuất VAT</span>
              </div>
            </div>
          </div>

          <div className="hero__art reveal">
            <HeroSlideshow />
          </div>
        </div>
      </section>

      {/* ============ ABOUT ============ */}
      <section className="section">
        <div className="container about-grid">
          <div className="about-grid__art reveal">
            <img src="/assets/img/deco-rings.svg" alt="" className="about-grid__ring about-grid__ring--tl" aria-hidden="true" />
            <img src="/assets/img/deco-rings.svg" alt="" className="about-grid__ring about-grid__ring--br" aria-hidden="true" />
            <figure className="about-photo">
              <img
                src={getImage('home_about', 0, 'https://ckjfwkgtjwiiolqqmnoc.supabase.co/storage/v1/object/public/site-assets/home_about/0-1779245797961.webp')}
                alt="Văn phòng Thế Thảo Pharma"
                width="1200"
                height="900"
                loading="lazy"
              />
            </figure>
            <div className="badge">
              <strong>2014</strong>
              <span>Thành lập tại Hà Nội</span>
            </div>
          </div>

          <div className="reveal">
            <span className="eyebrow">Về chúng tôi</span>
            <h2>Người đồng hành đáng tin cậy của nhà thuốc Việt Nam</h2>
            <p>
              Thành lập tháng 12/2014, Thế Thảo Pharma là đơn vị phân phối dược mỹ phẩm, thực phẩm chức năng và thiết bị y tế tại Việt Nam. Với <strong>12 năm hoạt động theo chuẩn GDP</strong>, chúng tôi tập trung cung cấp sản phẩm uy tín — chất lượng — đầy đủ pháp lý.
            </p>
            <p>
              Hơn cả một nhà phân phối, Thế Thảo là người bạn đồng hành cùng nhà thuốc lẻ và quầy thuốc truyền thống nâng cao năng lực kinh doanh, cập nhật xu hướng và phát triển bền vững giữa làn sóng cạnh tranh của các chuỗi lớn.
            </p>
            <div className="hero__actions" style={{ marginTop: '18px' }}>
              <Link className="btn btn--primary" to="/gioi-thieu">
                Câu chuyện thương hiệu
                <svg className="arr" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M5 12h14M13 5l7 7-7 7" />
                </svg>
              </Link>
              <Link className="btn btn--ghost" to="/tuyen-dung">
                Tham gia đội ngũ
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* ============ LĨNH VỰC ============ */}
      <section className="section section--soft">
        <div className="container">
          <div className="text-center reveal" style={{ maxWidth: '720px', marginInline: 'auto' }}>
            <span className="eyebrow">Lĩnh vực hoạt động</span>
            <h2>Chuyên kênh OTC — am hiểu sâu từng phân khúc</h2>
            <p className="lead" style={{ marginInline: 'auto' }}>
              Chúng tôi hiểu nhà thuốc, quầy thuốc và đại lý phân phối trên toàn quốc — từ thị trấn vùng cao tới phố đông nội đô.
            </p>
          </div>

          <div className="areas-grid">
            <div className="area-card reveal">
              <div className="icon-wrap">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <rect x="5" y="8" width="14" height="13" rx="3" />
                  <path d="M10 8V5h4v3" />
                  <path d="M8.5 5h7" />
                  <path d="M6 5v-1.5h8a1.5 1.5 0 0 1 1.5 1.5V5" />
                  <path d="M12 11.5v6M9 14.5h6" />
                </svg>
              </div>
              <h3>Dược mỹ phẩm</h3>
              <p>Phân phối dược mỹ phẩm từ các thương hiệu uy tín, đảm bảo nguồn gốc và chất lượng.</p>
            </div>
            <div className="area-card reveal">
              <div className="icon-wrap">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M12 2L4 6v6c0 5 3.5 9.5 8 10 4.5-.5 8-5 8-10V6l-8-4z" />
                  <path d="M9 12l2 2 4-4" />
                </svg>
              </div>
              <h3>Thực phẩm chức năng</h3>
              <p>TPCN chuẩn pháp lý, đáp ứng đủ điều kiện trong bối cảnh thị trường ngày càng siết chặt.</p>
            </div>
            <div className="area-card reveal">
              <div className="icon-wrap">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <circle cx="12" cy="12" r="9" />
                  <path d="M12 7v10M7 12h10" />
                </svg>
              </div>
              <h3>Thiết bị y tế</h3>
              <p>Cung cấp thiết bị y tế đạt chuẩn cho nhà thuốc, phòng khám và hệ thống y tế cơ sở.</p>
            </div>
            <div className="area-card reveal">
              <div className="icon-wrap">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
                  <circle cx="9" cy="7" r="4" />
                  <path d="M23 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75" />
                </svg>
              </div>
              <h3>Hỗ trợ &amp; đào tạo</h3>
              <p>Đào tạo chuyên môn, pháp lý, marketing &amp; vận hành — đồng hành nhà thuốc cạnh tranh bền vững.</p>
            </div>
          </div>
        </div>
      </section>

      {/* ============ POD - 3 KHÁC BIỆT ============ */}
      <section className="section">
        <div className="container">
          <div className="text-center reveal" style={{ maxWidth: '720px', marginInline: 'auto' }}>
            <span className="eyebrow">Ba khác biệt cốt lõi</span>
            <h2>Tại sao nhà thuốc chọn Thế Thảo?</h2>
            <p className="lead" style={{ marginInline: 'auto' }}>
              Ba điểm khác biệt được xây dựng từ <strong>12 năm</strong> đồng hành cùng nhà thuốc truyền thống — không chỉ là bán hàng, mà là tạo nền tảng phát triển bền vững.
            </p>
          </div>

          <div className="pod-grid">
            <article className="pod-card reveal">
              <div className="pod-header">
                <div className="pod-num">01</div>
                <span className="pod-kw">An tâm</span>
              </div>
              <h3>An tâm pháp lý — hàng sạch, giấy đủ</h3>
              <ul className="pod-list">
                <li>12 năm hoạt động theo tiêu chuẩn GDP</li>
                <li>100% hàng hoá xuất kho có đầy đủ hoá đơn, chứng từ — xuất VAT tự động</li>
                <li>Hệ thống FEFO nghiêm ngặt, không bán hàng cận date</li>
                <li>Đầy đủ giấy phép GPP, GPKD, MST</li>
              </ul>
            </article>

            <article className="pod-card reveal">
              <div className="pod-header">
                <div className="pod-num">02</div>
                <span className="pod-kw">Đồng hành</span>
              </div>
              <h3>Đồng hành phát triển — giúp nhà thuốc thịnh vượng</h3>
              <ul className="pod-list">
                <li>Đào tạo định kỳ: pháp lý dược, marketing, vận hành nhà thuốc</li>
                <li>Mạng lưới 20.000+ nhà thuốc cùng chia sẻ, học hỏi</li>
                <li>Tư vấn danh mục sản phẩm cạnh tranh với chuỗi lớn</li>
                <li>Data insight giúp quyết định kinh doanh chính xác</li>
              </ul>
            </article>

            <article className="pod-card reveal">
              <div className="pod-header">
                <div className="pod-num">03</div>
                <span className="pod-kw">Tận tâm</span>
              </div>
              <h3>Tận tâm phụng sự — dịch vụ chăm sóc số 1</h3>
              <ul className="pod-list">
                <li>Đứng đầu trải nghiệm khách hàng trong phân phối dược</li>
                <li>Founder &amp; đội ngũ biết tên, biết chuyện từng khách hàng</li>
                <li>Dự án "Tủ thuốc cho em" — lan toả giá trị nhân văn</li>
                <li>Sẵn sàng đồng hành cả ngoài giờ làm việc</li>
              </ul>
            </article>
          </div>
        </div>
      </section>

      {/* ============ TESTIMONIALS ============ */}
      <section className="section section--soft">
        <div className="container">
          <div className="text-center reveal" style={{ maxWidth: '720px', marginInline: 'auto' }}>
            <span className="eyebrow">Khách hàng nói gì</span>
            <h2>Phản hồi từ nhà thuốc đồng hành</h2>
            <p className="lead" style={{ marginInline: 'auto' }}>
              Hơn 20.000 nhà thuốc trên toàn quốc đã tin tưởng và lựa chọn Thế Thảo Pharma — đây là những chia sẻ thật từ khách hàng của chúng tôi.
            </p>
          </div>

          <div className="testi-grid">
            <article className="testi-card reveal">
              <div className="photo">
                <img
                  src={getImage('home_testimonials', 0, 'https://ckjfwkgtjwiiolqqmnoc.supabase.co/storage/v1/object/public/site-assets/home_testimonials/0-1779243965538.webp')}
                  alt="Chị Hải Quý — Hà Nam"
                  width="600"
                  height="450"
                  loading="lazy"
                />
              </div>
              <div className="body">
                <span className="name">Chị Hải Quý</span>
                <span className="loc">Hà Nam</span>
                <p className="quote">
                  Nhân viên nhiệt tình, chu đáo là thích mua hàng lắm nha, yên tâm chị ủng hộ lâu dài. Trước gọi nhiều chỗ hàng họ có vấn đề gì chẳng biết tìm ai xử lí, giờ chỉ gọi bên mình thôi cho dễ, giá cũng hợp lí hơn.
                </p>
              </div>
            </article>

            <article className="testi-card reveal">
              <div className="photo">
                <img
                  src={getImage('home_testimonials', 1, 'https://ckjfwkgtjwiiolqqmnoc.supabase.co/storage/v1/object/public/site-assets/home_testimonials/1-1779243970286.webp')}
                  alt="Nhà thuốc Trí Đức — Hà Nội"
                  width="600"
                  height="450"
                  loading="lazy"
                />
              </div>
              <div className="body">
                <span className="name">Nhà thuốc Trí Đức</span>
                <span className="loc">Hà Nội</span>
                <p className="quote">
                  Trước đây, ngày nào anh cũng lên chợ lấy hàng rất mất thời gian, tình cờ được bạn bè giới thiệu website đặt hàng, mình cũng vào tham khảo thử thì thấy đầy đủ mặt hàng, giao hàng nhanh…
                </p>
              </div>
            </article>

            <article className="testi-card reveal">
              <div className="photo">
                <img
                  src={getImage('home_testimonials', 2, 'https://ckjfwkgtjwiiolqqmnoc.supabase.co/storage/v1/object/public/site-assets/home_testimonials/2-1779243972749.webp')}
                  alt="Chị Hồng Thắm — Hà Nội"
                  width="600"
                  height="450"
                  loading="lazy"
                />
              </div>
              <div className="body">
                <span className="name">Chị Hồng Thắm</span>
                <span className="loc">Hà Nội</span>
                <p className="quote">
                  Mình rất thích đặt hàng trên website, đầy đủ mặt hàng đỡ mất công gọi lắt nhắt tốn kém mà giá cả cũng hợp lý, nhân viên nhiệt tình mình rất ưng ý. Mình sẽ ủng hộ Thế Thảo Pharma lâu dài.
                </p>
              </div>
            </article>
          </div>
        </div>
      </section>

      {/* ============ CSR ============ */}
      <section className="section">
        <div className="container">
          <div className="csr-banner reveal">
            <div>
              <span className="eyebrow" style={{ color: 'var(--c-green-400)' }}>Trách nhiệm xã hội</span>
              <h2>
                Tủ Thuốc Cho Em <span className="script">— ngàn tủ thuốc, triệu trái tim.</span>
              </h2>
              <p>
                Chương trình CSR của Thế Thảo Pharma kết nối những tấm lòng hảo tâm với điểm trường, trạm y tế vùng cao — nơi mỗi viên thuốc đều quý giá.
              </p>
              <div className="csr-stats">
                <div className="stat">
                  <strong><Counter end={parseInt(String(settings.csr_tu_thuoc || 425).replace(/\./g, ''), 10) || 425} /></strong>
                  <span>Tủ thuốc đã trao</span>
                </div>
                <div className="stat">
                  <strong><Counter end={parseInt(String(settings.csr_diem_truong || 425).replace(/\./g, ''), 10) || 425} /></strong>
                  <span>Điểm trường</span>
                </div>
                <div className="stat">
                  <strong><Counter end={parseInt(String(settings.csr_em_nho || 23671).replace(/\./g, ''), 10) || 23671} /></strong>
                  <span>Em nhỏ tiếp cận y tế</span>
                </div>
                <div className="stat">
                  <strong><Counter end={1000} /></strong>
                  <span>Mục tiêu tủ thuốc 2026</span>
                </div>
              </div>
              <div className="hero__actions" style={{ marginTop: '24px' }}>
                <Link className="btn btn--accent" to="/tu-thuoc-cho-em">
                  Tham gia chương trình
                  <svg className="arr" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M5 12h14M13 5l7 7-7 7" />
                  </svg>
                </Link>
              </div>
            </div>
            <figure className="csr-banner__art">
              <img
                src={getImage('home_csr', 0, 'https://ckjfwkgtjwiiolqqmnoc.supabase.co/storage/v1/object/public/site-assets/home_csr/0-1779243990772.webp')}
                alt="Tủ Thuốc Cho Em — trao quà vùng cao"
                width="900"
                height="900"
                loading="lazy"
              />
            </figure>
          </div>
        </div>
      </section>

      {/* ============ PARTNERS ============ */}
      <section id="partners" className="section">
        <div className="container">
          <div className="text-center reveal" style={{ maxWidth: '680px', marginInline: 'auto' }}>
            <span className="eyebrow">Đối tác đồng hành</span>
            <h2>Tin tưởng từ những thương hiệu hàng đầu</h2>
          </div>
          <PartnerGrid className="reveal" />
        </div>
      </section>

      {/* ============ CTA ============ */}
      <section className="section" style={{ paddingTop: 0 }}>
        <div className="container">
          <div className="cta-strip reveal">
            <div>
              <h2>Cùng Thế Thảo viết tiếp hành trình</h2>
              <p>
                Chúng tôi đang tìm những con người tử tế, ham học và dám làm để cùng vươn xa. Xem các vị trí đang tuyển — đội ngũ HR sẽ phản hồi trong 24 giờ làm việc.
              </p>
            </div>
            <Link className="btn btn--primary" to="/tuyen-dung">
              Xem cơ hội nghề nghiệp
              <svg className="arr" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round">
                <path d="M5 12h14M13 5l7 7-7 7" />
              </svg>
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
